import { render, staticRenderFns } from "./datatable-header.vue?vue&type=template&id=50e5df3c&lang=pug"
import script from "./datatable-header.vue?vue&type=script&lang=js"
export * from "./datatable-header.vue?vue&type=script&lang=js"
import style0 from "./datatable-header.vue?vue&type=style&index=0&id=50e5df3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports